import { Box, Divider, Paper, Skeleton } from '@mui/material';

export const TradingSidebarSkeleton = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Trade Header Skeleton (image/logo + title) */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Skeleton
          variant="rounded"
          width={44}
          height={44}
          sx={{ borderRadius: '10px', flexShrink: 0 }}
        />
        <Skeleton variant="text" width="60%" height={28} />
      </Box>

      {/* Tabs Skeleton */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Skeleton variant="text" width={40} height={24} />
          <Skeleton variant="text" width={40} height={24} />
        </Box>
        <Skeleton variant="rounded" width={80} height={32} />
      </Box>

      {/* Yes/No Buttons Skeleton */}
      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rounded" width="100%" height={40} sx={{ borderRadius: '8px' }} />
      </Box>

      {/* Amount Label Skeleton */}
      <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} />

      {/* Input Field Skeleton */}
      <Skeleton variant="rounded" width="100%" height={56} sx={{ mb: 1.5 }} />

      {/* Quick Add Buttons Skeleton */}
      <Box sx={{ display: 'flex', gap: 0.75, mb: 3 }}>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton
            key={i}
            variant="rounded"
            width="100%"
            height={32}
            sx={{ borderRadius: '6px' }}
          />
        ))}
      </Box>

      <Divider sx={{ mb: 2.5 }} />

      {/* Summary Lines Skeleton */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={60} height={20} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={60} height={20} />
        </Box>
      </Box>

      {/* Action Button Skeleton */}
      <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: '8px' }} />
    </Paper>
  );
};
